// extracted by mini-css-extract-plugin
export default {"mobileNavbar":"MobileNavbar_mobileNavbar__sfcNJ"};